import { createRouter, createWebHistory } from 'vue-router'
import ChatPage from './pages/ChatPage.vue'
import FilesPage from './pages/FilesPage.vue'
import DataPage from './pages/DataPage.vue'
import ImagesPage from './pages/ImagesPage.vue'
import LoginPage from './pages/LoginPage.vue'
import PaymentsPage from './pages/PaymentsPage.vue'
import RewardsPage from './pages/RewardsPage.vue'
import SyncPage from './pages/SyncPage.vue'
import FeedsPage from './pages/FeedsPage.vue'
import TasksPage from './pages/TasksPage.vue'
import AdminPage from './pages/AdminPage.vue'
import AdminColumnsPage from './pages/AdminColumnsPage.vue'
import FaqPage from './pages/FaqPage.vue'

// Функция проверки авторизации
const isAuthenticated = () => {
  const token = localStorage.getItem('access_token')
  return !!(token && token !== 'null' && token !== 'undefined')
}

// Guard для защищенных маршрутов
const authGuard = (to, from, next) => {
  if (isAuthenticated()) {
    next()
  } else {
    next('/login')
  }
}

// Guard для страницы логина
const loginGuard = (to, from, next) => {
  if (isAuthenticated()) {
    next('/chat')
  } else {
    next()
  }
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    beforeEnter: loginGuard
  },
  {
    path: '/',
    redirect: '/chat'
  },
  {
    path: '/chat',
    name: 'Chat',
    component: ChatPage,
    beforeEnter: authGuard
  },
  {
    path: '/files',
    name: 'Files',
    component: FilesPage,
    beforeEnter: authGuard
  },
  {
    path: '/data',
    name: 'Data',
    component: DataPage,
    beforeEnter: authGuard
  },
  {
    path: '/images',
    name: 'Images',
    component: ImagesPage,
    beforeEnter: authGuard
  },
  {
    path: '/payments',
    name: 'Payments',
    component: PaymentsPage,
    beforeEnter: authGuard
  },
  {
    path: '/rewards',
    name: 'Rewards',
    component: RewardsPage,
    beforeEnter: authGuard
  },
  {
    path: '/sync',
    name: 'Sync',
    component: SyncPage,
    beforeEnter: authGuard
  },
  {
    path: '/feeds',
    name: 'Feeds',
    component: FeedsPage,
    beforeEnter: authGuard
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: TasksPage,
    beforeEnter: authGuard
  },
  {
    path: '/faq',
    name: 'Faq',
    component: FaqPage,
    beforeEnter: authGuard
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPage,
    beforeEnter: authGuard,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/columns',
    name: 'AdminColumns',
    component: AdminColumnsPage,
    beforeEnter: authGuard,
    meta: { requiresAdmin: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
